// packages/base/src/settings/defaults.ts
//
// IV1-S3 — single source of truth for the workspace-relative RENDERED-VIEW
// output root.
//
// Pure string constant — ZERO dependencies (honours the base package's
// zero-vscode / zero-react / zero-fastify boundary rule).
/**
 * THE single source of truth for the workspace-relative directory where
 * **rendered** SysML v2 response-view artifacts (view.sysml / view.svg /
 * layout.json / manifest.json) are written and watched.
 *
 * Consumed (re-imported, never re-declared) by:
 *  - `views.outputPath` schema default (`settings/schema.ts`),
 *  - the `NodeAutoViewWriter` promote target (`chat-service-factory.ts`),
 *  - the `FileWatcher` `kb:viewRendered` trigger root (`files/file-watcher.ts`),
 *  - the views-layout route root (`routes/views.ts` via `layout-store.ts`).
 *
 * DISTINCT from — and intentionally NOT interchangeable with — the two
 * changeset roots, which are SEPARATE on-disk trees governed by the
 * changeset-staging / changeset-apply pipeline (NOT by `views.outputPath`):
 *
 *   1. The changeset **STAGING** root `'.tessa/views'` declared in
 *      `agent/tools/kb-tools/propose-kb-changeset.ts`. (That value is
 *      prod-overridden to `.tessa-lean/views` via
 *      chat-service-factory → orchestrator-runner, but it remains a
 *      separate constant with separate semantics.)
 *   2. The changeset **APPLY** store `'.tessa-lean/.pending'` resolved in
 *      `packages/server/src/index.ts` (the authoritative
 *      `ChangesetStateStore` reader). `.pending` is a SIBLING of the views
 *      root, not a child of it.
 *
 * Do NOT collapse this constant with either changeset root.
 */
export const DEFAULT_VIEWS_OUTPUT_PATH = '.tessa-lean/views';
//# sourceMappingURL=defaults.js.map